import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Avatar from '../../../common/avatar/avatar';
import DashboardOptions from '../../dashboard-options/dashboard-options';
import TextOverflowTooltip from '../../../common/TextOverflowTooltip';
import UserCheckmark from '../../../common/user-checkmark/user-checkmark';
import IconButton from '../../../common/icon-button/icon-button';
import Checkbox from '../../../common/form-elements/checkbox/checkbox';
/* Helpers */
import {getWidgetListWithNoDuplicatesAndSorted} from '../../../../helpers/dashboard-helpers';

class DashboardCard extends PureComponent {
  handleOnClick = () => {
    if (!this.props.isExportMode) {
      this.props.openDashboardPage(this.props.dashboard)();
    }
  };

  render() {
    return (
      <div className="glu-col-xs-24 glu-col-md-8 glu-col-lg-6 glu-col-pad--md">
        <div
          className={`glu-content glu-dashboard-card cursor-pointer${
            this.props.isHighLighted ? ' glu-dashboard--highlighted' : ''
          }`}
          onClick={this.handleOnClick}
        >
          <div className="glu-content__header glu-content__header--lg">
            {this.props.image ? <Avatar imageSrc={this.props.image} /> : null}
            <div className="glu-flex glu-flex-col dashboard-title-created glu-h3">
              <TextOverflowTooltip
                title={this.props.dashboard.title}
                renderChildren={(ref) => (
                  <div className="dashboard-title" ref={ref}>
                    {this.props.dashboard.title}
                  </div>
                )}
              />
              <div className="dashboard-created-by">
                {this.props.dashboard.modalFormData.selectedPermissionSettingsId === 1 && (
                  <IconButton icon="private" />
                )}
                <UserCheckmark
                  label="Created by: "
                  ownerId={this.props.dashboard.ownerId}
                  userLabel={this.props.dashboard.createdBy}
                />
              </div>
              {this.props.dashboard.createdIn ? (
                <div className="dashboard-created-in">
                  Created in: {this.props.dashboard.createdIn}
                </div>
              ) : null}
            </div>
            {!this.props.isMobileDevice && (
              <div className="dashboard-options" tooltip-id="dashboard-options">
                {this.props.isExportMode ? (
                  <Checkbox
                    // className="dashboard-checkbox"
                    onChange={this.props.toggleCheckedForExport}
                    isChecked={this.props.isCheckedForExport}
                  />
                ) : (
                  <DashboardOptions
                    className="dashboard-options"
                    dashboard={this.props.dashboard}
                    toggleDashboardModal={this.props.toggleDashboardModal}
                    addDashboardToFavorite={this.props.addDashboardToFavorite}
                    removeDashboardFromFavorites={this.props.removeDashboardFromFavorites}
                    onClone={this.props.onClone}
                    openEditPage={this.props.openEditPage}
                    handleDashboardInfoClick={this.props.handleDashboardInfoClick}
                    queryParams={this.props.queryParams}
                    onExportDashboard={this.props.onExportDashboard}
                  />
                )}
              </div>
            )}
          </div>
          <div className="glu-content__body">
            <pre className="glu-content-pre dashboard-description glu-content__section">
              {this.props.dashboard.description ? this.props.dashboard.description : ' '}
            </pre>
            <div
              className="
                            glu-content__section
                            glu-content__separator
                            glu-content__separator--inner
                            glu-card__separator"
            >
              <div className="glu-h4 text-bold">Tags</div>
            </div>
            <div className="glu-content__section">{this.props.renderDashboardTags()}</div>
            <div
              className="
                            glu-content__section
                            glu-content__separator
                            glu-content__separator--inner"
            >
              <div className="glu-h4 text-bold">Widget list</div>
            </div>
            <div className="glu-content__section">
              <div className="text-secondary glu-widget-list dashboard-description">
                {this.props.dashboard.widgetTitleList.length > 0
                  ? getWidgetListWithNoDuplicatesAndSorted(
                      this.props.dashboard.widgetTitleList
                    ).join(', ')
                  : '-'}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DashboardCard.propTypes = {
  dashboard: PropTypes.objectOf(PropTypes.any).isRequired,
  renderDashboardTags: PropTypes.func.isRequired,
  toggleDashboardModal: PropTypes.func.isRequired,
  addDashboardToFavorite: PropTypes.func.isRequired,
  removeDashboardFromFavorites: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
  openEditPage: PropTypes.func.isRequired,
  handleDashboardInfoClick: PropTypes.func.isRequired,
  openDashboardPage: PropTypes.func.isRequired,
  isHighLighted: PropTypes.bool.isRequired,
  image: PropTypes.string,
  queryParams: PropTypes.objectOf(PropTypes.any),
  isMobileDevice: PropTypes.bool,
  isExportMode: PropTypes.bool,
};

DashboardCard.defaultProps = {
  image: null,
  queryParams: {},
  isMobileDevice: false,
  isExportMode: false,
};

function mapStateToProps(state) {
  return {
    isMobileDevice: state.userReducer.isMobileDevice,
    isExportMode: state.dashboardReducer.isExportMode,
  };
}

export default connect(mapStateToProps)(DashboardCard);
